import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import Field from "./field.tsx";

interface DocumentSectionProps {
  fields: { label: string; value: string }[];
  files: {
    filename: string;
    temporaryUrl: string;
    metadata: {
      idTipoDocumento: string;
      tipoDocumento: string;
      titulo: string;
    };
  }[];
  hideViewIcon?: boolean;
}

function DocumentSection({
  fields,
  files,
  hideViewIcon = false,
}: DocumentSectionProps): React.JSX.Element {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(true);

  const handleOpenFile = (temporaryUrl: string): void => {
    window.open(temporaryUrl, "_blank");
  };

  return (
    <Stack spacing={3} sx={{ width: "100%" }}>
      <div>
        <Typography gutterBottom variant="h6">
          {t("document.title")}
        </Typography>
        <Typography color="text.secondary" variant="body1">
          Acesso aos arquivos e outras informações
        </Typography>
      </div>
      <div>
        <Stack
          alignItems={{ xs: "flex-start", sm: "center" }}
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          spacing={1}
        >
          <Typography gutterBottom sx={{ mb: { xs: 0, sm: 1 } }} variant="h6">
            Tipo de Documentos
          </Typography>
          <Stack
            alignItems="flex-end"
            direction="column"
            spacing={1}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            {files.map((file) => (
              <Stack
                alignItems="center"
                direction="row"
                justifyContent="space-between"
                key={file.temporaryUrl}
                sx={{ width: { xs: "100%", sm: "auto" } }}
              >
                <Typography
                  color="text.secondary"
                  sx={{ wordBreak: "break-all", textAlign: "right" }}
                  variant="body1"
                >
                  {file.filename}
                </Typography>
                {!hideViewIcon && (
                  <IconButton
                    onClick={() => {
                      handleOpenFile(file.temporaryUrl);
                    }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                )}
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Stack alignItems="end">
          <div>
            <Button
              onClick={() => {
                setShowDetails(!showDetails);
              }}
            >
              {!showDetails ? t("document.showDetails") : t("document.hideDetails")}
            </Button>
          </div>
        </Stack>
      </div>
      <Collapse in={showDetails}>
        <Grid container spacing={3}>
          {fields.map(({ label, value }) => (
            <Grid key={label + value} size={{ xs: 12, sm: 6, md: 4 }}>
              <Field label={label} value={value} />
            </Grid>
          ))}
        </Grid>
      </Collapse>
    </Stack>
  );
}

export default DocumentSection;
